module.exports = __webpack_public_path__ + "static/3-cc6b5a4fd11b0aa2298a2a7642222cc9.jpg";